module.exports = angular.module('cartographer.common.ui.animation', [])

$ = require 'jquery'

module.exports.animation '.animate-fade', $DI (crtLog) ->
  # crtLog.debug('Loading animate-fade')
  return {
    enter: (element, done) ->
      # crtLog.debug('animate-fade.enter', element)
      $(element).fadeIn('fast', done)
      return (canceled) ->
        if canceled then $(element).hide() else $(element).show()
        return

    leave: (element, done) ->
      # crtLog.debug('animate-fade.leave', element)
      $(element).fadeOut('fast', done)
      return (canceled) ->
        if canceled then $(element).show() else $(element).hide()
        return

    beforeAddClass: (element, className, done) ->
      # crtLog.debug('animate-fade.beforeAddClass', element, className)
      if className == 'ng-hide'
        $(element).fadeOut('fast', done)
      else
        done()
      return (canceled) ->
        if className == 'ng-hide'
          if canceled then $(element).show() else $(element).hide()
        return

    removeClass: (element, className, done) ->
      # crtLog.debug('animate-fade.removeClass', element, className)
      if className == 'ng-hide'
        $(element).removeClass('ng-hide').fadeIn('fast', done)
      else
        done()
      return (canceled) ->
        if className == 'ng-hide'
          if canceled then $(element).hide() else $(element).show()
        return
  }

module.exports.animation '.animate-slide', $DI (crtLog) ->
  # crtLog.debug('Loading animate-slide')
  return {
    enter: (element, done) ->
      # crtLog.debug('animate-slide.enter', element)
      $(element).hide().slideDown('fast', done)
      return (canceled) ->
        if canceled then $(element).hide() else $(element).show()
        return

    leave: (element, done) ->
      # crtLog.debug('animate-slide.leave', element)
      $(element).slideUp('fast', done)
      return (canceled) ->
        if canceled then $(element).show() else $(element).hide()
        return

    beforeAddClass: (element, className, done) ->
      # crtLog.debug('animate-slide.beforeAddClass', element, className)
      if className == 'ng-hide'
        $(element).slideUp('fast', done)
      else
        done()
      return (canceled) ->
        if className == 'ng-hide'
          if canceled then $(element).show() else $(element).hide()
        return

    removeClass: (element, className, done) ->
      # crtLog.debug('animate-slide.removeClass', element, className)
      if className == 'ng-hide'
        $(element).removeClass('ng-hide').slideDown('fast', done)
      else
        done()
      return (canceled) ->
        if className == 'ng-hide'
          if canceled then $(element).hide() else $(element).show()
        return
  }
